import { render, staticRenderFns } from "./FilterArea.vue?vue&type=template&id=50d048fc"
import script from "./FilterArea.vue?vue&type=script&lang=js"
export * from "./FilterArea.vue?vue&type=script&lang=js"
import style0 from "./FilterArea.vue?vue&type=style&index=0&id=50d048fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports